import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../../context/AuthContext';
import {
  Menu, X, LayoutDashboard, Users, Building, BarChart3, Settings, Shield
} from 'lucide-react';

const CFTSidebar = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  const { currentUser } = useAuth();

  // Only show admin sidebar for internal users
  if (!currentUser || currentUser.userType === 'client') {
    return null;
  }

  const navigationItems = [
    { name: 'Overview', path: '/tiles/client_facing_tools', icon: <LayoutDashboard className="w-5 h-5" /> },
    { name: 'Client Users', path: '/tiles/client_facing_tools/client-users', icon: <Users className="w-5 h-5" /> },
    { name: 'Business Units', path: '/tiles/client_facing_tools/business-units', icon: <Building className="w-5 h-5" /> },
    { name: 'Analytics', path: '/tiles/client_facing_tools/analytics', icon: <BarChart3 className="w-5 h-5" /> },
    { name: 'Portal Settings', path: '/tiles/client_facing_tools/settings', icon: <Settings className="w-5 h-5" /> },
    { name: 'Access Control', path: '/tiles/client_facing_tools/access', icon: <Shield className="w-5 h-5" /> }
  ];

  const isActive = (path) => {
    return location.pathname === path;
  };

  return (
    <>
      <button
        className="lg:hidden fixed top-4 left-4 z-50 p-2 rounded-md bg-slate-800 text-slate-200"
        onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
      >
        {isMobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
      </button>

      {isMobileMenuOpen && (
        <div
          className="lg:hidden fixed inset-0 bg-black bg-opacity-50 z-40"
          onClick={() => setIsMobileMenuOpen(false)}
        />
      )}

      <div
          className={`fixed inset-y-0 left-0 z-40 transition-transform duration-300 transform 
            ${isMobileMenuOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'}
            h-screen bg-slate-800 border-r border-slate-700 w-64 overflow-y-auto`}
      >
        <div className="p-4 border-b border-slate-700/50">
          <Link 
            to="/"
            className="flex items-center px-4 py-2 text-sm text-slate-300 hover:bg-slate-700/50 hover:text-slate-100 rounded-md"
          >
            <span className="mr-3">←</span>
            <span>Back to HQ</span>
          </Link>
        </div>

        <nav className="mt-4">
          <div className="mb-6">
            <h3 className="px-4 mb-2 text-xs font-semibold text-slate-400 uppercase tracking-wider">
              Client Portal Management
            </h3>
            <div>
              {navigationItems.map(item => (
                <Link 
                  key={item.path} 
                  to={item.path}
                  className={`flex items-center px-4 py-2 text-sm ${
                    isActive(item.path)
                      ? 'bg-blue-600 text-white'
                      : 'text-slate-300 hover:bg-slate-700/50 hover:text-slate-100'
                  }`}
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  <span className="mr-3">{item.icon}</span>
                  <span>{item.name}</span>
                </Link>
              ))}
            </div>
          </div>
        </nav>
      </div>
    </>
  );
};

export default CFTSidebar;